import React from 'react'
import '../styles/main.css'


export default function Skill() {
    return (
        <section className='skills' data-aos="fade-up" data-aos-duration="500" data-aos-easing="ease-in-out-quad">
            <h2>
                <span className='beautify'>02. </span>Skills
            </h2>
            <ul className="list">
                <li className="box"><img src='/img/c-.png' alt="C++" width="100px" /></li>
                <li className="box"><img src='/img/python.png' alt="Python" width="100px" /></li>
                <li className="box"><img src='/img/icons8-java.svg' alt="Java" width="100px" /></li>
                <li className="box"><img src='/img/html-5.png' alt="html5" width="100px" /></li>
                <li className="box"><img src='/img/css-3.png' alt="CSS3" width="100px" /></li>
                <li className="box"><img src='/img/js (1).png' alt="Javascript" width="100px" /></li>
                <li className="box"><img src='/img/logo512.png' alt="React" width="100px" /></li>
                <li className="box"><img src='/img/git-icon-logo-svgrepo-com.svg' alt="Git" width="100px" /></li>
                <li className="box"><img src='/img/nodejs-svgrepo-com.svg' alt="Node" width="100px" /></li>
                <li className="box"><img src='/img/postgresql-logo.svg' alt="Psql" width="100px" /></li>
                <li className="box"><img src='/img/mongodb-svgrepo-com.svg' alt="Mongo" width="100px" /></li>
                <li className="box"><img src='/img/spring-boot.svg' alt="Spring" width="100px" /></li>
                <li className="box"><img src='/img/docker.svg' alt="Docker" width="100px" /></li>
            </ul>
        </section>
    )
}
